<template>
  <div class="row">
    <div class="col-lg-6">
      <p>
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
            style="width:20px;height:20px;"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
            />
          </svg>
        </span>
        {{ title }}
      </p>
    </div>
    <div class="col-lg-2">
      <p><span>Provider:</span> {{ total_rating_provider }}</p>
    </div>
    <div class="col-lg-2">
      <p>
        <span>Point:</span>
        <span v-if="point != null" class="text-dark">
          {{ point }}
        </span>
        <svg v-if="point === null" class="spinner" viewBox="0 0 50 50">
          <circle
            class="path"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke-width="5"
          ></circle>
        </svg>
      </p>
    </div>
     <div class="col-lg-2">
      <p>
        <span>Avarage:</span>
        <span v-if="point != null" class="text-dark">
          {{ point > 0 ?(parseInt(point)/total_rating_provider).toFixed(2):0}}
        </span>
        <svg v-if="point===null" class="spinner" viewBox="0 0 50 50">
          <circle
            class="path"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke-width="5"
          ></circle>
        </svg>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "RatingRow",
  props: ["eid", "title", "total_rating_provider", "category_id"],
  data() {
    return {
      point: null
    };
  },
  mounted() {
    this.getCategoryRatingPoint();
  },
  methods: {
    getCategoryRatingPoint() {
      axios
        .get(
          `https://api.diu.ac/bapi/profile/profile-rating-details?id=${this.eid}&category_id=${this.category_id}`
        )
        .then(res => {
          this.point = res.data;
        })
        .catch(error => console.error(error));
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/RatingRow.vue